var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('router-view'):_c('div',{staticClass:"section has-text-centered"},[_c('span',{staticClass:"icon is-large has-text-primary"},[_c('i',{staticClass:"fas fa-3x fa-spinner fa-spin"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }